import React, {useEffect, useState} from 'react';
import triangle from '../images/Simple_triangle.svg';
import './DeathlyHallows.scss';

const DeathlyHallows = () => {
    const [elderClass, setElderClass] = useState('elder-wand-animate');
    const [stoneClass, setStoneClass] = useState('resurrection-stone-animate');
    const [cloakClass, setCloakClass] = useState('the-cloak-animate');

    useEffect(() => {
        setTimeout(() => setElderClass('elder-wand-animate'), 1);
        setTimeout(() => setStoneClass('resurrection-stone-animate'), 1);
        setTimeout(() => setCloakClass('the-cloak-animate'), 1);
    }, [elderClass]);

    const stopAnimations = () => {
        setElderClass('elder-wand');
        setStoneClass('resurrection-stone');
        setCloakClass('the-cloak');
    };

    return (
        <div className="animation-container">
            <img alt='triangle' className={cloakClass} src={triangle} />
            <div className={elderClass} onAnimationEnd={() => setTimeout(() => stopAnimations(), 750)} />
            <div className={stoneClass} />
        </div>
    );
};

export default DeathlyHallows;
